//App
import { RoleApiType } from "./types/apiTypes";
import apiClient from "../../apiClient/apiClient";
import endPoints from "./endPoints";

const roleApi: RoleApiType = {
  get: (value) => apiClient.get(endPoints.role.get(value)),
  getAll: () => apiClient.get(endPoints.role.getAll()),
  save: (payload) => apiClient.post(endPoints.role.save(), payload),
  delete: (value) => apiClient.delete(endPoints.role.delete(value)),
};

export default roleApi;
